/**
 * Pieces shared by the tour action modals: the summary rows that show what the
 * user is acting on, and the error + dismiss/confirm footer.
 */
import React from 'react';
import styles from './TourModals.module.css';

/**
 * @param {object} props
 * @param {Array<{label: string, value: string}>} props.details - Summary rows.
 */
export function TourModalDetails({ details = [] }) {
  if (details.length === 0) return null;
  return (
    <dl className={styles.details}>
      {details.map(({ label, value }) => (
        <div key={label} className={styles.detailRow}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}

/**
 * @param {object} props
 * @param {string|null} [props.error] - Error from the last attempt.
 * @param {boolean} [props.submitting] - Request in flight; disables both buttons.
 * @param {string} [props.dismissLabel] - Dismiss button text.
 * @param {string} props.confirmLabel - Confirm button text.
 * @param {string} props.busyLabel - Confirm button text while submitting.
 * @param {'primary'|'danger'} [props.tone] - Confirm button style.
 * @param {() => void} props.onDismiss
 * @param {() => void} props.onConfirm
 */
export function TourModalFooter({
  error = null,
  submitting = false,
  dismissLabel = 'Go back',
  confirmLabel,
  busyLabel,
  tone = 'primary',
  onDismiss,
  onConfirm,
}) {
  return (
    <>
      {error && (
        <p role="alert" className={styles.error}>
          {error}
        </p>
      )}
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.btnSecondary}
          onClick={onDismiss}
          disabled={submitting}
        >
          {dismissLabel}
        </button>
        <button
          type="button"
          className={tone === 'danger' ? styles.btnDanger : styles.btnPrimary}
          onClick={onConfirm}
          disabled={submitting}
        >
          {submitting ? busyLabel : confirmLabel}
        </button>
      </div>
    </>
  );
}
